module.exports = __webpack_public_path__ + "static/img/how1.f151f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/how1.png
// module id = R7t1
// module chunks = 1